import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { useLocale } from "../../hooks/useLocale";
import type { Locale } from "../../lib/types";

const OPTIONS: Array<{ id: Locale; label: string }> = [
  { id: "ar", label: "العربية" },
  { id: "en", label: "EN" },
];

/** AR ⇄ EN toggle. Flips the whole UI between RTL and LTR (see applyDocumentLocale). */
export function LanguageSwitch({ dark = false }: { dark?: boolean }) {
  const { t } = useTranslation();
  const { locale, setLocale } = useLocale();
  const { changeLocale, user } = useAuth();
  return (
    <div role="group" aria-label={t("common.language")} className={`flex items-center rounded-xl p-1 text-xs font-bold ${dark ? "border border-[#262C66] bg-[#161A42]" : "bg-gray-100"}`}>
      {OPTIONS.map((o) => (
        <button
          key={o.id}
          type="button"
          aria-pressed={locale === o.id}
          onClick={() => (user ? void changeLocale(o.id) : void setLocale(o.id))}
          className={`rounded-lg px-2.5 py-1.5 transition ${locale === o.id ? "bg-cosmic-purple text-white" : dark ? "text-gray-400 hover:text-white" : "text-gray-500 hover:text-cosmic-navy"}`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
